import React from 'react';
import { injectIntl } from 'react-intl';
import { Row, Col, Alert } from 'react-bootstrap';

import { pipelineOptionFromEntity } from 'components/forms/autocomplete/Pipeline';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormInput from 'components/forms/FormInput';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormWhiteLabelProject from 'components/forms/FormWhiteLabelProject';

class LeadCatcherData extends EntityPropsUpdater {
  updateWhiteLabelProject = (fieldName, whiteLabelProject) => {
    this.updateEntity(fieldName, whiteLabelProject.id);
  };

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      disabled,
      inModal,
    } = this.props;

    return (
      <div className="clearfix">
        {entityLoaded && (
          <Row>
            <Col xs={12} md={inModal ? 12 : 6}>
              <div className="panel panel-transparent">
                <div className="panel-body">
                  {!!entity.getId() && (
                    <Alert bsStyle="info" class="m-b-30">
                      {messages.email}: catcher{entity.getId()}@creacheck.com
                    </Alert>
                  )}

                  <p className="form-group-title">{messages.formGroup.basic_information}</p>
                  <div className="form-group-attached">
                    <FormWhiteLabelProject
                      onChange={this.updateWhiteLabelProject}
                      selectedWhiteLabelProject={entity.getWhiteLabelProject()}
                      meta={entity.getWhiteLabelProjectMetaInformation()}
                      validation={entity.getWhiteLabelProjectValidationResult()}
                      disabled={disabled}
                    />
                    <FormAutocomplete
                      label={messages.pipeline}
                      name="pipeline"
                      value={pipelineOptionFromEntity(entity.getPipeline())}
                      meta={entity.getPipelineMetaInformation()}
                      validation={entity.getPipelineValidationResult()}
                      onChange={this.updateEntity}
                      returnValueObject
                      autocompleteType="pipeline"
                      disabled={disabled}
                    />
                    <FormInput
                      name="source"
                      label={messages.source}
                      value={entity.getSource()}
                      meta={entity.getSourceMetaInformation()}
                      validation={entity.getSourceValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}
LeadCatcherData.defaultProps = {
  inModal: false,
};

export default injectIntl(LeadCatcherData);
